/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Box, Typography, Skeleton, Stack } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { FormCard } from '@/components/cards/FormCard';
import { useParams } from 'react-router-dom';
import { useGetFormsQuery } from '@/features/forms/formsApi';
import { getPipelineName } from '@/utils/constants';

export const FormsTab = () => {
	const params = useParams();
	const isClient = Boolean(params?.clientId);

	const { dealRow, clientRow } = useObjectContext();

	const brokerGroupId = clientRow?.brokerGroupId;

	// Gets the specific forms based on the deal's pipeline
	const dealPipeline = dealRow?.pipeline ? getPipelineName(dealRow?.pipeline) : '';

	const { data: forms, ...formsQuery } = useGetFormsQuery(
		{ brokerRef: brokerGroupId, ...(!isClient && { dealPipeline }) },
		{ skip: !brokerGroupId || (!isClient && !dealPipeline) },
	);

	// const formsQuery = useGetFormsQuery(
	// 	{ dealPipeline: dealPipeline, brokerRef: brokerGroupId },
	// 	{ skip: !dealPipeline || !brokerGroupId || !canViewDeal }
	// );

	function sortFormsByName(forms) {
		return forms.slice().sort((a, b) => {
			if (a.name < b.name) {
				return -1;
			}
			if (a.name > b.name) {
				return 1;
			}
			return 0;
		});
	}

	const sortedForms = useMemo(() => sortFormsByName(forms ?? []), [forms]);

	return (
		<Stack spacing={2}>
			{!formsQuery.isError && !formsQuery.isSuccess ? (
				<Skeleton variant='text' width={'100%'} height={40} />
			) : sortedForms.length > 0 ? (
				sortedForms.map((form, index) => (
					<FormCard key={`forms-tab-form-${index}`} form={form} />
				))
			) : (
				<Typography textAlign={'center'}>No forms are available.</Typography>
			)}
		</Stack>
	);
};
FormsTab.displayName = 'FormsTab';
